import { useEffect, useState } from 'react';
import Sidebar from '../views/components/Sidebar';
import Topbar from '../views/components/Topbar';
import { markdownToHtml } from '../scripts/utils';
import { cleanMessage } from '../views/helpers';
import { versionHistory } from '../views/components/UserStateProvider';

const WhatsChanged = () => {
    const [versions, setVersions] = useState([]);

    useEffect(() => {
        (async () => {
            const versionHistoryClone = [...versionHistory];

            for(let i = 0; i < versionHistoryClone.length; i++) {
                const { version } = versionHistoryClone[i];
                const response = await fetch(`/releases/${version}.md`);
                const data = await response.text();
                versionHistoryClone[i].content = data;
            }

            setVersions(versionHistoryClone.reverse());
        })();
        
    }, []);

    return (
        <>
            <div id="history" className="d-flex">
                <Sidebar />
                <div className="flex-grow-1">
                    <Topbar title="What's Changed" backButton />
                    <div className="content-wrapper tif-pt-md-50 tif-pt-25 tif-px-md-60 tif-px-30 tif-pb-85 tif-pb-45">
                        {
                            versions.map(({ version, date, content }) => (
                                <section key={version} className="tif-mb-50">
                                    <h2 className="tif-h3 fw-bold">v{version} ({date})</h2>
                                    <div dangerouslySetInnerHTML={{ __html: markdownToHtml(cleanMessage(content)) }} />
                                </section>
                            ))
                        }
                    </div>
                </div>
            </div>
        </>
    );
};

export default WhatsChanged;